import { useAppContext } from "@context/app";
import { useUI } from "@context/ui-managed-context";
import Button from "@elements/button";
// import Button from "@elements/redesign/Button/Button";
import CloseIcon from "@svg/closeIcon";
import { COOKIE_IGNORE_PHONE_VERIFICATION, COOKIE_IGNORE_PHONE_VERIFICATION_CHECKOUT } from "@utils/constants";
import { getCookie } from "@utils/Cookies";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";

interface VerifyPhoneNumberExitProps {

}

const VerifyPhoneNumberExit: React.FC<VerifyPhoneNumberExitProps> = () => {
  const { setModalView, openModal, closeModal, modalView } = useUI()
  const t = useTranslations()
  const Cookies = getCookie();
  const { locale, pathname } = useRouter()
  const { syncData } = useAppContext()
  const [initialSeconds, setInitialSeconds] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);
  const [timerFinished, setTimerFinished] = useState<boolean>(false);


  const defaultStep: "OTP" | "PHONE_NUMBER" | undefined = modalView.args[1]
  const time: number | undefined = modalView.args[2]
  const onComplete: undefined | ((finishedAndVerified: boolean) => void) = modalView.args[3]
  const modalContext: string | undefined = modalView.args[4]

  useEffect(() => {
    if (time) {
      setInitialSeconds(time)
      setSeconds(time)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time])

  useEffect(() => {
    if (!timerFinished) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 0) {
            clearInterval(timer);
            setTimerFinished(true);
            return 0;
          }
          return prevSeconds - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [initialSeconds, timerFinished]);

  const options = useMemo(() => {
    // Check for digital gift context directly
    if (modalContext === "digital_gift") {
      return {
        isOptional: syncData?.wallet_digital_gift_phone_verification === "optional",
        interval: 0,
        cookie: COOKIE_IGNORE_PHONE_VERIFICATION
      }
    }

    switch (pathname) {
      case "/settings":
        return {
          isOptional: true,
          interval: 0,
          cookie: ""
        }
      case "/wallet":
        return {
          isOptional: true,
          interval: 0,
          cookie: ""
        }
      case "/checkout":
        return {
          isOptional: syncData?.phone_verification_checkout.mode === "optional",
          interval: syncData?.phone_verification_checkout.interval,
          cookie: COOKIE_IGNORE_PHONE_VERIFICATION_CHECKOUT
        }

      default:
        return {
          isOptional: syncData?.phone_verification.mode === "optional",
          interval: syncData?.phone_verification.interval,
          cookie: COOKIE_IGNORE_PHONE_VERIFICATION
        }
    }
  }, [pathname, syncData, modalContext]);

  const { isOptional, interval = 86400, cookie } = options

  const handelClose = () => {
    if (!isOptional) {
      Cookies.set(cookie, "true", {}, interval / 86400);
    }
    onComplete?.(false)
    closeModal()
  }
  const handelVerify = () => {
    const suggestedPhone: string | undefined = modalView.args[0]
    setModalView("VERIFY_PHONE_NUMBER", false, suggestedPhone, defaultStep || undefined, seconds, onComplete, modalContext);
    openModal();
  }
  return (
    <div className="md:w-[480px] sm:w-screen xs:w-screen w-screen max-w-[480px] h-max" dir={locale?.includes("ar-") ? "rtl" : "ltr"}>
      <div className="w-full min-h-[282px] h-max bg-white rounded-3xl p-6 flex flex-col gap-3 items-center md:rounded-3xl rounded-b-none">
        <div className="w-full flex justify-end">
          <button className=" outline-none" onClick={() => handelVerify()} >
            <CloseIcon />
          </button>
        </div>
        <div className="flex-1 flex flex-col gap-3 items-center justify-center w-full">
          <h3 className=" text-black text-xl font-normal leading-8 text-center">{t("client_phoneverify_exitverification")}</h3>
          <p className=" text-mui-text-secondary text-center text-sm font-medium leading-5 max-w-80 mt-2">{t("client_phoneverify_exitverificationdesc")}</p>
          <div className=" w-full grid grid-cols-2 gap-4 mt-10">
            <Button
              theme="lightBlue"
              className="!font-medium !h-12 rounded-full text-sm "
              onClick={handelClose}
            >
              {t("client_buttons_exitanyway")}
            </Button>
            <Button
              theme="blue"
              className="!font-bold !h-12 rounded-full text-sm "
              onClick={handelVerify}
            >
              {t("client_buttons_stayverify")}
            </Button>
            {/* <Button theme="primaryOutline" label={t("client_buttons_exitanyway")} size="small" className=" !font-medium !h-12" onClick={handelClose} />
            <Button theme="primary" label={t("client_buttons_stayverify")} size="small" className=" !font-bold !h-12" onClick={handelVerify} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyPhoneNumberExit;